import {useEffect} from 'react'

import Loading from '../../common/components/List/Loading.js'
import {
  refreshStocktakeList,
  stocktakeListQuerySelector,
  isLoadingSelector,
} from './stocktakeListFunctions.js'
import StocktakeListFooter from './StocktakeListFooter.js'
import Table from './Table.js'
import {useSelector} from '../../store.js'

export default function List() {
  const query = useSelector(stocktakeListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)

  useEffect(() => {
    refreshStocktakeList()
  }, [query])

  return (
    <>
      {isLoading ? (
        <div className="medium-12 columns list--empty-content margin-top-40 margin-bottom-40">
          <Loading />
        </div>
      ) : (
        <div className="medium-12 columns">
          <Table />
          <StocktakeListFooter />
        </div>
      )}
    </>
  )
}
